import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionIntro from 'components/common/SectionIntro';
import { useCropsAnalyticsData } from 'hooks/useCropsAnalyticsData';
import { useDateRanges } from 'hooks/useDateRanges';
import { useWorkdaySummary } from 'hooks/useWorkdaySummary';
import AgroSection from './AgroSection';
import DataSection from './DataSection';
import WorkersSection from './WorkersSection';

const CropsAnalytics = () => {
  const { t } = useTranslation();
  const { cropsAnalyticsData } = useCropsAnalyticsData();
  const dates = useDateRanges();
  const { data: workdayData } = useWorkdaySummary();

  if (cropsAnalyticsData.loading) {
    return (
      <div className="min-h-screen p-6 text-slate-100">
        <div className="flex justify-center items-center h-64">
          <div className="text-lg text-slate-400">{t('dashboard.loadingCropsAnalytics')}</div>
        </div>
      </div>
    );
  }

  if (cropsAnalyticsData.error) {
    return (
      <div className="min-h-screen p-6 text-slate-100">
        <div className="flex justify-center items-center h-64">
          <div className="text-lg text-rose-300">{cropsAnalyticsData.error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 text-slate-100">
      <SectionIntro
        kicker={t('pageIntro.dashboardKicker')}
        title={t('dashboard.cropsAnalyticsDashboard')}
        description={t('pageIntro.cropsAnalyticsDescription')}
      />

      <hr className="workspace-summary-divider my-5 border-t" />

      <AgroSection data={cropsAnalyticsData} dates={dates} />

      <DataSection
        data={cropsAnalyticsData}
        dates={dates}
        type="picking"
        title={t('dashboard.pickingSummary')}
        color="blue"
      />

      <DataSection
        data={cropsAnalyticsData}
        dates={dates}
        type="packing"
        title={t('dashboard.packingSummary')}
        color="purple"
      />

      <WorkersSection
        cropsAnalyticsData={cropsAnalyticsData}
        workdayData={workdayData}
        previousDate={dates.previousDate}
      />
    </div>
  );
};

export default CropsAnalytics;
